export const PscRoutes = {
    SavePsc: "Psc/SavePsc",
    GetPsc: "Psc/GetPsc",
    ChangeStatus: "Psc/ChangeStatus",
    RemovePsc: "Psc/RemovePsc",
    GetPscClientModel: "Psc/GetPscClientModel",
    GetDeficiencyDetails:"Psc/GetPscDeficiencyDetails",
    ActivateOrDeactivateSafetyScore: "Psc/ActivateOrDeactivateSafetyScore",
    UpdatedPscDeficiencyDetails: "Psc/UpdatedPscDeficiencyDetails",
    OverridePscDetails: "Psc/OverridePscDetails",
    UpsertPscInspectionDeficiency: "Psc/UpsertPscInspectionDeficiency",
    RemovePscInspectionDeficiency: "Psc/RemovePscInspectionDeficiency",
    GetPscThumbnailZipFile: "Psc/GetPscThumbnailZipFile",
    GetPscCloseOutDocumentLinks: "Psc/GetPscCloseOutDocumentLinks",
    ExtractPscCloseoutDocumentsData: "Psc/ExtractPscCloseoutDocumentsData",
    GetPscSetting: "Psc/GetPscSetting"
}
